import axios from 'axios'
import config from '../config'
import { getDoctorToken } from '../utils'

const getQuickSupportApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}quick-support/question-answer/Doctor`,
        method: "get",
        params: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`
        }
    })

    return response

}

export default getQuickSupportApi